import '../css/map.css';
import { useEffect } from 'react';

function Test(props) {


  //스크립트 파일 읽어오기
  const new_script = src => { 
    return new Promise((resolve, reject) => { 
      const script = document.createElement('script'); 
      script.src = src; 
      script.addEventListener('load', () => { 
        resolve(); 
      }); 
      script.addEventListener('error', e => { 
        reject(e); 
        console.log(e);
      }); 
      document.head.appendChild(script); 
    }); 
  };
  
  useEffect(() => { 
    //카카오맵 스크립트 읽어오기
    const my_script = new_script('https://dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=27687584189cea08443d50c19dad4710');
    
    
    console.log(props.gungdo);
    console.log(props.weedo);  
    console.log(props.mapid);  


    //스크립트 읽기 완료 후 카카오맵 설정
    my_script.then(() => { 
      console.log('script loaded!!!');  
      const kakao = window['kakao']; 
      kakao.maps.load(() => {
        const mapContainer = document.getElementById(props.mapid);
        const options = { 
          center: new kakao.maps.LatLng(props.gungdo, props.weedo), //좌표설정
          level: 3 
        }; 
        console.log('script loassssssssssssssssssssssded!!!');  
        const map = new kakao.maps.Map(mapContainer, options); //맵생성

        
        //마커설정
        const markerPosition = new kakao.maps.LatLng(props.gungdo, props.weedo); 
        const marker = new kakao.maps.Marker({ 
          position: markerPosition
        }); 
        marker.setMap(map); 


        
      });   
    }); 
  }, []);





  return (
      <div   id={props.mapid} className="map"/> // 고유한 ID 사용

  );
}

export default Test;